import classNames from "classnames"

import LayoutItem from "../Layouts/LayoutItem"

import TextButton from "@components/elements/V2/Buttons/TextButton"
import IconInfoBlock from "@components/elements/V2/IconInfoBlock"
import ArrowIcon from "@components/elements/V2/Icons/ArrowIcon"
import { Color } from "@constants/V2/color"
import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"
import React from "react"

type Props = {
  title: string
  description: string
  thumbnailUrl?: string
  thumbnailAlt?: string
  policyUrl: string
  backgroundColor: Color
  size: "large" | "medium" | "small"
  mobileGridOrder?: number
}

const PolicyCard = ({
  title,
  description,
  thumbnailUrl,
  thumbnailAlt,
  policyUrl,
  backgroundColor = Color.LightGray,
  size = "medium",
  mobileGridOrder,
  ...props
}: Props) => {
  const accentColor = getAccentColor(backgroundColor)

  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as="div"
      animateOnScroll
      className={classNames(
        getBackgroundColorClass(backgroundColor),
        "p-lg rounded-md col-span-full flex flex-col justify-between gap-16 md:col-span-3 lg:col-span-4"
      )}
      {...props}
    >
      <IconInfoBlock
        size={size}
        textColor={accentColor}
        titleText={title}
        bodyText={description}
        iconUrl={thumbnailUrl}
        iconAlt={thumbnailAlt}
      />

      {policyUrl && (
        <TextButton
          color={accentColor}
          text="View"
          linkUrl={policyUrl}
          opensNewTab
          style="icon"
          icon={<ArrowIcon />}
        />
      )}
    </LayoutItem>
  )
}

export default PolicyCard
